'use strict';
import { j as o } from "../../external/react/jsx-runtime.js";
import { faChevronDown as n } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as i } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import m from "../../external/classnames/index.js";
import d from "html-react-parser";
import r from "./accordion.module.scss.js";
const h = ({
  className: e,
  title: a,
  isActive: t = !1,
  onClick: s,
  content: c
}) => /* @__PURE__ */ o.jsxs(
  "div",
  {
    className: m(r.accordion__item, e),
    "data-expanded": t,
    "data-testid": "accordion-item",
    children: [
      /* @__PURE__ */ o.jsxs("button", { className: r.accordion__button, onClick: s, children: [
        /* @__PURE__ */ o.jsx("p", { children: a }),
        /* @__PURE__ */ o.jsx(i, { icon: n, "data-active": t })
      ] }),
      /* @__PURE__ */ o.jsx("div", { className: r.accordion__content, role: "region", children: d(c) })
    ]
  }
);
export {
  h as default
};
